module.exports = __webpack_public_path__ + "static/media/mainImg.86777269.jpg";